// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3izbv","range":"MonthRangeSwitch_range__2zZI-","disabled":"MonthRangeSwitch_disabled__4lrtn"};